import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useIsMobile } from '@/hooks/utilities/use-mobile';
import Seo from '@/components/shared/Seo';
import PageTransition from '../shared/PageTransition';
import { useSession } from '@/contexts/LitSessionProvider';
import FullScreenGuard from '../auth/FullScreenGuard';
import useGetNotificationSettings from '@/hooks/settings/useGetNotificationSettings';
import useAppDetails from '@/hooks/utilities/useAppDetails';
import MobileMenu from '@/components/shared/MobileMenu';
import SearchHome from './mobile/SearchHome';
import DTSearchHome from './desktop/DTSearchHome';
import FeedPage from '@/pages/feed';
import PortfolioPage from '@/pages/portfolio';
import SettingsPage from '@/pages/settings';
import AssetPage from '@/pages/asset';
import HistoryPage from '@/pages/history';
import AccountSettingsPage from '@/pages/settings/account';
import SettingsDeletePage from '@/pages/settings/delete';
import AdminSettingsPage from '@/pages/admin/settings';
import NotificationsSettingsPage from '@/pages/settings/notifications';
import SettingsSecurityPage from '@/pages/security';
import SettingsWalletPage from '@/pages/wallets';
const HomeController = ({
  userName
}: {
  userName?: string;
}) => {
  const isMobile = useIsMobile();
  const seoString = userName ? `Join ${userName} on Genius • Trade Crypto Like a Genius • Find the Hottest New Tokens on Genius Terminal` : 'Explore • Find the Hottest New Tokens on Genius Terminal • Trade Crypto Like a Genius';
  const router = useRouter();
  const query = router.query;

  // To do refactor mode (search) and m_mode (mobile mode)
  const {
    mobileMode,
    setMobileMode,
    setMobileModeMetadata,
    mobileModeMetadata
  } = useAppDetails();
  useEffect(() => {
    if (query?.m_mode && query?.m_mode !== mobileMode) {
      setMobileMode(query.m_mode as any);
    }
    if (query?.networkId && query?.address) {
      if (mobileModeMetadata?.address !== query.address) {
        setMobileModeMetadata({
          networkId: query.networkId as string,
          address: query.address as string
        });
      }
    }
  }, [query]);
  const {
    PKP
  } = useSession();

  // Initializes notification settings for new users, todo refactor
  const {
    notificationSettings: _
  } = useGetNotificationSettings();
  if (isMobile) {
    return <>
        {(mobileMode == 'home' || mobileMode == 'search') && <div className='no-scrollbar'>
            <Seo title={seoString} />
            <PageTransition key={mobileMode}>
              <FullScreenGuard>
                <SearchHome setSelectToAsset={() => {
              return;
            }} />
              </FullScreenGuard>
            </PageTransition>
          </div>}

        {mobileMode == 'feed' && <PageTransition key={mobileMode}>
            <FeedPage />
          </PageTransition>}

        {mobileMode == 'portfolio' && <PageTransition key={mobileMode}>
            <PortfolioPage />
          </PageTransition>}

        {mobileMode == 'settings' && <PageTransition key={mobileMode}>
            <SettingsPage />
          </PageTransition>}
        {mobileMode == 'settings_wallets' && <PageTransition key={mobileMode}>
            <SettingsWalletPage />
          </PageTransition>}
        {mobileMode == 'settings_account' && <PageTransition key={mobileMode}>
            <AccountSettingsPage />
          </PageTransition>}
        {mobileMode == 'settings_security' && <PageTransition key={mobileMode}>
            <SettingsSecurityPage />
          </PageTransition>}
        {mobileMode == 'settings_notifications' && <PageTransition key={mobileMode}>
            <NotificationsSettingsPage />
          </PageTransition>}

        {mobileMode == 'settings_account_del' && <PageTransition key={mobileMode}>
            <SettingsDeletePage />
          </PageTransition>}
        {mobileMode == 'settings_admin' && <PageTransition key={mobileMode}>
            <AdminSettingsPage />
          </PageTransition>}

        {mobileMode == 'asset' && <PageTransition key={mobileMode}>
            <AssetPage routerNetworkId={query.networkId as string} routerAddress={query.address as string} routerFromUnverified={Boolean(query.fromUnverified as string)} />
          </PageTransition>}

        {mobileMode == 'history' && <PageTransition key={mobileMode}>
            <HistoryPage orderId={query.orderId as string} />
          </PageTransition>}

        {PKP?.ethAddress && PKP?.username && <MobileMenu />}
      </>;
  } else {
    return <div className='h-full overflow-clip'>
        <Seo title={seoString} />
        <DTSearchHome />
      </div>;
  }
};
export default HomeController;